import React, { Component } from "react";
import {
  Input,
  Button,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Alert,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  FormText,
} from "reactstrap";
import * as Constdata from "../../Constants/ApiConstants";
// import Header from "../HeaderComponent/Header";
import SerraError from "../CommonComponent/Error";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";
import SerraLoader from "../CommonComponent/Loader";
import { connect } from "react-redux";
import * as message from "../../Constants/MessageConstant";
import "./signinStyle.css";
import { FaEye } from "react-icons/fa6";
import { FaEyeSlash } from "react-icons/fa6";
import CryptoJS from "crypto-js";
import { apiFetch } from "../../Constants/CommonConstant";
import { resetRefreshTimer } from "../../reducers/datasSourceRefreshListener";

const options = [
  {
    label: "SELECT",
    value: "SELECT",
  },
  {
    label: "AWS",
    value: "AWS",
  },
  {
    label: "AZURE",
    value: "AZURE",
  },
];

class Signin extends Component {
  constructor(props) {
    super(props);
    this.processResponse = this.processResponse.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleAliasChange = this.handleAliasChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onShowAlert = this.onShowAlert.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleLoginRetry = this.toggleLoginRetry.bind(this);
    this.handleForgot = this.handleForgot.bind(this);
    this.handleFotgotResponse = this.handleFotgotResponse.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.handleSendEmailRequest = this.handleSendEmailRequest.bind(this);
    this.handleProviderChange = this.handleProviderChange.bind(this);
    this.onTermsAndConditionsClick = this.onTermsAndConditionsClick.bind(this);
    this.onPrivacyPolicyClick = this.onPrivacyPolicyClick.bind(this);
    this.handleAlternateIdCheck = this.handleAlternateIdCheck.bind(this);
    this.state = {
      aliasUsername: "",
      username: "",
      password: "",
      check: false,
      hidden: true,
      visible: "",
      message: "",
      alertMsg: false,
      errorMsg: "Email ID and/or Password is invalid",
      data: "",
      modal: false,
      errormessage: "",
      errorPopup: false,
      Changeusername: "",
      disableSignIn: true,
      modalLoader: false,
      showLoginRetry: false,
      forceLogout: false,
      providerName: "AWS",
      loggedInUser: "",
      isAlternateIdCheck: false,
    };
  }
  componentDidMount() {
    console.log("location");
    ReactGA.initialize(message.MeasurementId);
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Sign In",
    });
    this.props.registerListners();
    apiFetch(Constdata.SESSIONACTIVE_URL, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then(async (responseJson) => {
        if (responseJson.success === true) {
          apiFetch(Constdata.ISPLANSELECTED_URL, {
            method: "GET",
            credentials: "include",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=UTF-8",
            },
          })
            .then((responseJson) => {
              this.planprocessResponse(responseJson);
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((error) => {});
  }

  planprocessResponse = (response) => {
    if (response.success === true && response.data.landingPage !== "card") {
      this.setState({ data: response.data });

      if (
        (response.orgInfo.plan === "Free Trial" ||
          response.orgInfo.plan === "FREE_TRIAL") &&
        response.orgInfo.loggedInUser !== "support@serralabs.com" &&
        response.orgInfo.userName !== "support@serralabs.com"
      ) {
        apiFetch(Constdata.GETALLACCOUNT_URL, {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        }).then(async (responseJson) => {
          this.setState({
            modalLoader: false,
          });

          let newDSList;
          const isEmptyAnalysis =
            responseJson.orgInfo.freeTrialAnalysisList &&
            responseJson.orgInfo.freeTrialAnalysisList.every(
              (type) => type === ""
            );
          if (responseJson.orgInfo.providerName === "AWS") {
            newDSList = responseJson.data.awsConfigs;
            if (newDSList && newDSList.length > 0 && !isEmptyAnalysis) {
              this.props.history.push({
                pathname: `/dashboard`,
                state: {
                  providerName: response.orgInfo.providerName,
                  step: 1,
                },
              });
            } else {
              this.props.history.push({
                pathname: `/free-trial`,
                state: {
                  providerName: response.orgInfo.providerName,
                  step:
                    newDSList && newDSList.length > 0 && isEmptyAnalysis
                      ? 3
                      : 1,
                },
              });
            }
          } else {
            newDSList = responseJson.data.configs;

            if (newDSList && newDSList.length > 0 && !isEmptyAnalysis) {
              this.props.history.push({
                pathname: `/dashboard`,
                state: {
                  providerName: response.orgInfo.providerName,
                  step: 1,
                },
              });
            } else {
              this.props.history.push({
                pathname: `/free-trial`,
                state: {
                  providerName: response.orgInfo.providerName,
                  step:
                    newDSList && newDSList.length > 0 && isEmptyAnalysis
                      ? 3
                      : 1,
                },
              });
            }
          }
        });
      } else {
        if (response.data.landingPage === "report") {
          this.props.history.push({
            pathname: `/${response.data.landingPage}`,
            state: { data: this.state.data.data },
          });
        } else {
          this.props.history.push({
            pathname: `/${response.data.landingPage}`,
            state: { data: this.state.data },
          });
        }
      }
    } else if (response.success === false) {
      this.setState({ errorMsg: response.message });
    }
  };

  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };
  toggleLoginRetry = () => {
    this.setState((prevState) => ({
      showLoginRetry: !prevState.showLoginRetry,
    }));
    this.setState({ disableSignIn: false });
  };
  handleForgot = (event) => {
    const { Changeusername } = this.state;
    event.preventDefault();
    const payload = {
      username: Changeusername,
    };
    apiFetch(Constdata.RESETPASSWORD_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((responseJson) => {
        this.handleFotgotResponse(responseJson);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  handleFotgotResponse = (response) => {
    if (response.success === true) {
      this.setState({ errorPopup: true, errormessage: response.message });
    } else {
      this.setState({ errorPopup: true, errormessage: response.message });
    }
  };
  handlePasswordChange = async (e) => {
    await this.setState({ password: e.target.value });
    var usernamePresent = false;
    var passPresent = false;
    if (this.state.username) {
      usernamePresent = true;
    }
    if (this.state.password) {
      passPresent = true;
    }
    await this.setState({ disableSignIn: !(usernamePresent && passPresent) });
  };

  handleAliasChange = async (e) => {
    await this.setState({ aliasUsername: e.target.value });
    var usernamePresent = false;
    var passPresent = false;
    if (this.state.username) {
      usernamePresent = true;
    }
    if (this.state.password) {
      passPresent = true;
    }
    await this.setState({ disableSignIn: !(usernamePresent && passPresent) });
  };

  handleEmailChange = async (e) => {
    await this.setState({
      username: e.target.value,
      Changeusername: e.target.value,
    });
    var usernamePresent = false;
    var passPresent = false;
    if (this.state.username) {
      usernamePresent = true;
    }
    if (this.state.password) {
      passPresent = true;
    }
    await this.setState({ disableSignIn: !(usernamePresent && passPresent) });
  };
  handleSendEmailRequest = (e) => {
    this.setState({ Changeusername: e.target.value });
  };
  handleCheck = () => {
    this.setState({ check: true });
  };
  handleProviderChange = (e) => {
    console.log("Provider Selected!!");
    let name = e.target.value;
    console.log(" provider name: " + name);
    this.setState({ providerName: name });
  };

  handleSubmit = (event) => {
    this.setState({ disableSignIn: true, modalLoader: true });
    const { username, password, forceLogout } = this.state;
    if (event !== undefined) {
      event.preventDefault();
    }

    const encryptedPassword = CryptoJS.AES.encrypt(
      password,
      process.env.REACT_APP_SecretKey
    ).toString();

    const payload = {
      username: username.toLowerCase(),
      password: encryptedPassword,
      forceLogout: forceLogout,
      providerName: this.state.providerName,
      aliasUsername: this.state.isAlternateIdCheck
        ? this.state.aliasUsername.toLowerCase()
        : "",
    };

    fetch(Constdata.LOGIN_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.processResponse(responseJson);
      })
      .catch(async (error) => {
        console.error(error);
      });
  };
  handleLoginRetry = async () => {
    await this.setState({ forceLogout: true });
    await this.handleSubmit();
  };
  processResponse = async (response) => {
    if (response.success === true) {
      this.props.startRefreshTimer();
      await this.props.processLogin(true);
      window.localStorage.setItem(
        "loggedInUser",
        this.state.username.toLowerCase()
      );
      this.setState({
        visible: response.success,
        data: response.data,
      });
      this.state.aliasUsername !== ""
        ? this.setState({ loggedInUser: this.state.aliasUsername })
        : this.setState({ loggedInUser: this.state.loggedInUser });

      if (
        (response.orgInfo.plan === "Free Trial" ||
          response.orgInfo.plan === "FREE_TRIAL") &&
        response.orgInfo.loggedInUser !== "support@serralabs.com" &&
        response.orgInfo.userName !== "support@serralabs.com"
      ) {
        apiFetch(Constdata.GETALLACCOUNT_URL, {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        }).then(async (responseJson) => {
          this.setState({
            modalLoader: false,
          });

          let newDSList;
          const isEmptyAnalysis =
            responseJson.orgInfo.freeTrialAnalysisList &&
            responseJson.orgInfo.freeTrialAnalysisList.every(
              (type) => type === ""
            );
          if (responseJson.orgInfo.providerName === "AWS") {
            newDSList = responseJson.data.awsConfigs;
            if (newDSList && newDSList.length > 0 && !isEmptyAnalysis) {
              this.props.history.push({
                pathname: `/dashboard`,
                state: {
                  providerName: response.orgInfo.providerName,
                  step: 1,
                },
              });
            } else {
              this.props.history.push({
                pathname: `/free-trial`,
                state: {
                  providerName: response.orgInfo.providerName,
                  step:
                    newDSList && newDSList.length > 0 && isEmptyAnalysis
                      ? 3
                      : 1,
                },
              });
            }
          } else {
            newDSList = responseJson.data.configs;

            if (newDSList && newDSList.length > 0 && !isEmptyAnalysis) {
              this.props.history.push({
                pathname: `/dashboard`,
                state: {
                  providerName: response.orgInfo.providerName,
                  step: 1,
                },
              });
            } else {
              this.props.history.push({
                pathname: `/free-trial`,
                state: {
                  providerName: response.orgInfo.providerName,
                  step:
                    newDSList && newDSList.length > 0 && isEmptyAnalysis
                      ? 3
                      : 1,
                },
              });
            }
          }
        });
      } else {
        this.setState({
          modalLoader: false,
        });
        if (response.data.landingPage === "report") {
          this.props.history.push({
            pathname: `/${
              response.orgInfo.loggedInUser === "support@serralabs.com"
                ? "dashboard"
                : response.data.landingPage
            }`,
            state: { data: this.state.data.data },
          });
        } else {
          this.props.history.push({
            pathname: `/${
              response.orgInfo.loggedInUser === "support@serralabs.com"
                ? "dashboard"
                : response.data.landingPage
            }`,
            state: { data: this.state.data },
          });
        }
      }
    } else {
      if (response.message === "Another user session is already active.") {
        this.setState({
          errorMsg: response.message,
          modalLoader: false,
          showLoginRetry: true,
        });
      } else {
        await this.setState({
          errorMsg: response.message,
          visible: response.success,
          disableSignIn: false,
          modalLoader: false,
        });
        await this.onShowAlert();
      }
    }
  };
  toggleShow = () => {
    this.setState({ hidden: !this.state.hidden });
  };
  onShowAlert = () => {
    this.setState({ alertMsg: true }, () => {
      window.setTimeout(() => {
        this.setState({ alertMsg: false });
      }, 5000);
    });
  };
  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    this.toggle();
  };

  onTermsAndConditionsClick() {
    window.open(this.props.companyDetails.TermsAndConditions);
  }

  onPrivacyPolicyClick() {
    window.open(this.props.companyDetails.PrivacyPolicy);
  }

  handleAlternateIdCheck = () => {
    this.setState({ isAlternateIdCheck: !this.state.isAlternateIdCheck });
  };

  render() {
    const { visible, Changeusername } = this.state;
    const message =
      visible === false ? (
        <Alert color="danger" isOpen={this.state.alertMsg}>
          {this.state.errorMsg}
        </Alert>
      ) : (
        ""
      );

    return (
      <div className="signinNewDesign">
        <div className="background-container"></div>

        <div className="login-container">
          <div className="login-form">
            <div className="logo-container">
              <img src={this.props.companyDetails.LOGO} alt="Serra Labs Logo" />
            </div>

            <h1 className="form-title">Console Sign-in</h1>

            <div className="signup-link">
              New user?
              <span>
                <Link to={"/signup"} style={{ fontSize: "16px" }}>
                  {" "}
                  Try for free
                </Link>
              </span>
            </div>

            <div className="gradient-divider"></div>
            <div>{message}</div>
            <form onSubmit={this.handleSubmit}>
              <FormGroup className="mb-3">
                <Input
                  type="email"
                  className="form-control"
                  placeholder="Business Email"
                  id="email"
                  value={this.state.username}
                  onChange={this.handleEmailChange}
                  required
                />
              </FormGroup>

              <FormGroup className="mb-2 password-input-group position-relative">
                <Input
                  type={this.state.hidden ? "password" : "text"}
                  className="form-control"
                  placeholder="Password"
                  id="password"
                  style={{ paddingRight: "50px" }}
                  value={this.state.password}
                  onChange={this.handlePasswordChange}
                  required
                />
                <Button
                  type="button"
                  className="eyeButton btn-link position-absolute"
                  style={{
                    border: "none",
                    background: "none",
                    color: "#6a6a6a",
                  }}
                  onClick={this.toggleShow.bind(this)}
                >
                  {this.state.hidden ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </FormGroup>

              <div className="mb-4">
                <Link onClick={this.toggle} className="forgot-password">
                  Forgot Password?
                </Link>
              </div>

              <FormGroup className="mb-4">
                <Label for="cloudProvider" className="form-label">
                  Cloud Provider
                </Label>
                <Input
                  type="select"
                  className="form-select"
                  id="cloudProvider"
                  value={this.state.providerName}
                  onChange={this.handleProviderChange}
                >
                  {options.map((option) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </Input>
              </FormGroup>

              <div className="mb-4">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="loginAsAlternate"
                    value={this.state.isAlternateIdCheck}
                    onChange={this.handleAlternateIdCheck}
                  />
                  <Label
                    check
                    className="form-check-label"
                    for="loginAsAlternate"
                  >
                    Login As Alternate ID
                  </Label>

                  {this.state.isAlternateIdCheck ? (
                    <>
                      <Label style={{ fontSize: "12px" }}>
                        Login as another user from the same organization.
                      </Label>
                      <FormGroup className="mb-3">
                        <Input
                          type="email"
                          className="form-control"
                          id="aliasUsername"
                          placeholder="Enter Another Email ID"
                          value={this.state.aliasUsername}
                          onChange={this.handleAliasChange}
                        />
                      </FormGroup>
                    </>
                  ) : null}
                </FormGroup>

                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="rememberMe"
                    value={this.state.check}
                    onChange={this.handleCheck}
                  />
                  <Label check className="form-check-label" for="rememberMe">
                    Remember Me
                  </Label>
                </FormGroup>
              </div>

              <div className="d-flex justify-content-end">
                <Button
                  type="submit"
                  className="btn-signin"
                  id={
                    (this.state.disableSignIn ||
                      this.state.isAlternateIdCheck) &&
                    !this.state.aliasUsername
                      ? "btnSinginSignup_disabledNew"
                      : "btnSinginSignupNew"
                  }
                  disabled={
                    (this.state.disableSignIn ||
                      this.state.isAlternateIdCheck) &&
                    !this.state.aliasUsername
                  }
                >
                  Sign In
                </Button>
              </div>
            </form>
          </div>
        </div>

        <div className="footer">
          <span className="">
            © Copyright Serra Labs, Inc. {new Date().getFullYear()}
          </span>
          <span className="footerSlash"> | </span>
          <Link
            onClick={this.onTermsAndConditionsClick}
            className=""
            style={{ fontSize: "11px" }}
          >
            Terms and Conditions
          </Link>
          <span className="footerSlash"> | </span>
          <Link
            onClick={this.onPrivacyPolicyClick}
            className=""
            style={{ fontSize: "11px" }}
          >
            Privacy Policy
          </Link>
        </div>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          backdrop={"static"}
          centered={true}
        >
          <ModalHeader
            id="modalheader_list"
            cssModule={{ "modal-title": "modalHeader" }}
            toggle={this.toggle}
          >
            <div
              className="modalCompanyName"
              dangerouslySetInnerHTML={{
                __html: message.SerraLabsModalHeader,
              }}
            />
            <div className="modalTitle">Forgot Password?</div>
          </ModalHeader>
          <ModalBody>
            <form onSubmit={this.handleForgot}>
              <div className="form-group">
                <Input
                  type="email"
                  className="form-control"
                  id="Changeusername"
                  placeholder="Enter Your Email Id"
                  value={this.state.Changeusername}
                  onChange={this.handleSendEmailRequest}
                  required
                />
              </div>
              <Button
                type="submit"
                id={
                  !Changeusername
                    ? "btnSinginSignup_disabled"
                    : "btnSinginSignup"
                }
                value="Submit"
                disabled={!Changeusername}
                block
              >
                Send Email
              </Button>
            </form>
          </ModalBody>
        </Modal>
        <Modal
          size="lg"
          isOpen={this.state.showLoginRetry}
          toggle={this.toggleLoginRetry}
          backdrop={"static"}
          centered={true}
        >
          <ModalHeader
            id="modalheader_list"
            cssModule={{ "modal-title": "modalHeader" }}
            toggle={this.toggleLoginRetry}
          >
            <div
              className="modalCompanyName"
              dangerouslySetInnerHTML={{
                __html: message.SerraLabsModalHeader,
              }}
            />
            <div className="modalTitle">Active Session</div>
          </ModalHeader>
          <ModalBody>
            <div className="box-titel" id="modaldis_list">
              <div>
                <p>
                  There is another active session for user{" "}
                  {this.state.aliasUsername !== ""
                    ? this.state.aliasUsername
                    : this.state.username}
                </p>
              </div>
            </div>
            <form onSubmit={this.handleForgot}>
              <div align="center">
                <Button
                  id="confirmbtn_list"
                  style={{ width: "375px" }}
                  onClick={this.handleLoginRetry}
                >
                  Terminate other session and continue
                </Button>
                <Button
                  id="canclebtn_list"
                  onClick={() => {
                    this.toggleLoginRetry();
                  }}
                >
                  Will try again later
                </Button>
              </div>
            </form>
          </ModalBody>
        </Modal>

        {this.state.errorPopup === true ? (
          <SerraError
            Errordata={this.state.errormessage}
            ErrorPopup={this.state.errorPopup}
            setErrorMethod={this.setErrorPopupState}
          ></SerraError>
        ) : (
          ""
        )}
        {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    companyDetails: state.companyDetails.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startRefreshTimer: () => resetRefreshTimer(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
